import { catchError, shareReplay, tap } from 'rxjs/operators';
import { EventRecordFromCreator, GlobalData, events$, ofTrace } from '../event-store';
import { HoneycombProvider } from '../honeycomb-provider';
import { EMPTY } from 'rxjs';
import { Tracer } from '@opentelemetry/api';
import { GenerateCsvPlanEvents, HelixCsvExportEvents } from '../events/csv-export';

type CsvPlanEvent = EventRecordFromCreator<GenerateCsvPlanEvents>;

const generateEvents = new Map<string, CsvPlanEvent>();

function getSpanName(action: string) {
  switch (action) {
    case 'generate-designer-plan':
      return 'designer_csv_export';
    case 'generate-report-plan':
      return 'report_csv_export';
  }

  return '';
}

export function init(globalData: GlobalData, honeycomb: HoneycombProvider) {
  const tracer = honeycomb.tracerProvider.getTracer('webapp-ui');
  const stream$ = events$.pipe(shareReplay(1));
  stream$
    .pipe(
      ofTrace<HelixCsvExportEvents>('helix-csv-export'),
      tap((ev) => {
        if (ev.traceId) {
          switch (ev.action) {
            case 'generate-report-plan':
            case 'generate-view-data-plan':
            case 'generate-designer-plan': {
              generateEvents.set(ev.traceId, ev);
              break;
            }
            case 'csv-export-success': {
              const startEvent = generateEvents.get(ev.traceId);
              if (startEvent) {
                const span = createSpan(globalData, tracer, startEvent, true);
                span.end(ev.timestamp);
              }
              generateEvents.delete(ev.traceId);
              break;
            }
            case 'csv-export-failed': {
              const startEvent = generateEvents.get(ev.traceId);
              if (startEvent) {
                const span = createSpan(globalData, tracer, startEvent, false);
                span.end(ev.timestamp);
              }
              generateEvents.delete(ev.traceId);
              break;
            }
          }
        }
      }),
      catchError(() => EMPTY) // Don't care about errors here for now
    )
    .subscribe();
}

function createSpan(globalData: GlobalData, tracer: Tracer, csvEvent: CsvPlanEvent, success: boolean) {
  return tracer.startSpan('mode.webapp_ui.' + getSpanName(csvEvent.action), {
    startTime: csvEvent?.timestamp,
    attributes: {
      'mode.core.user_name': globalData.username,
      'mode.core.organization_name': globalData.account,
      'mode.webapp_ui.url': csvEvent.url,
      'mode.webapp_ui.csv_export.success': success,
      'mode.webapp_ui.csv_export.token':
        csvEvent.action !== 'generate-view-data-plan' ? csvEvent.chartToken : csvEvent.switchViewToken,
      'mode.webapp_ui.csv_export.row_count': csvEvent.rowCount,
    },
  });
}
